export enum PageEnum {
  BASE_LOGIN = '/login',
  SIGN_UP = '/sign-up',
  BASE_HOME = '/home',
  ORGANIZATION = '/organization',
  USERMANGMENT = '/user-management',
  USERMANGMENTDETAL = '/organization/detail',
  TYPESETTING = '/organization/type-setting',
  USRTGROUP = '/user-management/group',
  SET_PASSWORD = '/set-password',
  RESET_PASSWORD = '/reset-password',
  JOIN_CREAT = '/invites-join-fusion',
  CHOOSE_ORGAN = '/choose-organization',
  NO_PERMISS = '/no-permission',
  JOIN_SUCCESS = '/join-success',
  LINK_EXPIRED = '/link-expired',
  BUILDING = '/building',
  LIFT = '/lift',
  LMD = '/lmd',
  ALARMS = '/alarms',
  ALARMLF = '/alarms/lift-fault',
  ALARMPT = '/alarms/passenger-trap',
  ALARMRBE = '/alarms/rbe',
  FORGET_PASS = '/forget-password',
  CASE_MANAGDE = '/case-management',
  CASE_MANAGDETAL = '/case-management/view',
  CASE_MANAGDEADD = '/case-management/new',
  CASE_MANAGDEDETAL = '/case-management/edit',
  OMS_SCHEDULE = '/oms-schedule',
  AI_HOTLINE = '/ai-hotline',
}
export enum TABLEPAI {
  LOGIN = '/api/login',
  GROUP = '/api/group/page',
  USER = '/api/user/page',
  ORGANIZA = '/api/organization/page',
  TYPES = '/api/organization/types',
  ORGAPERMISS = '/api/organization/type/permissions',
  INVITEHIS = '/api/user/invite/page', // 邀请记录
  GROUP_PERMISS = '/api/group/permissions',
  LIFT_PAGE = '/api/lift/page',
  LMD_PAGE = '/api/lmd/page',
  BUILD_PAGE = '/api/building/page',
  ALARM_RBE = '/api/alarm/rbe/page',
  ALARM_DEVICE = '/api/alarm/device/page',
  LIFT_FAULT = '/api/lift/fault/page',
  LIFT_COMPLAINT = '/api/lift/complaint/page',
  LIFT_TRAP = '/api/passenger/trap/page',
  RBE_CODE = '/api/alarm/alarm-types',
  REP_PT_MONTH = '/api/reports/month-pt/page',
  USER_PROPERTS = '/api/properties/user',
  MONTH_BREAKDOWN = '/api/reports/month-breakdown/page',
  DIVISION = '/api/reports/tcmr-division',
  LIFTCOMPANY = '/api/reports/tcmr-lift-company',
  DIVISION_LIFTCOMPANY = '/api/reports/tcmr-dlc',
  LM_SCHEDULE = '/api/lm-schedule',
  LM_CHECKER = '/api/lm-checker',
  CASE_LIFT_STATUS = '/api/lift/complaint/lift-complaint-telemetry',
  CASE_FEEDBACK = '/api/lift/complaint/list',
  OMS_PAGE = '/api/oms-schedule/realtime/page',
  CHRON_LIFT = '/api/reports/chronic-lifts/summary-page',
  AI_CALL = '/api/ai-call/page',
}

export const REMEMBERPASS = 'app:remember_password';
export const USERINFO = 'app:user_information';
export const ISLOGIN = 'auth:islogin';
export const COLLAPS = 'app:menu:collapse';
export const THEME_ENUM = 'app:config:theme_enum';
export const ORGAN_TYPE = 'app:config:organization_type';
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const SUPERUSER = 'SUPERUSER';
export const SOFT_GRID = 'SOFT_GRID';
export const USER_MANAG = 'user_management';
export const MANAG_USER = 'user_management.user';
export const ORGANIZ = 'organization';
export const OPTION_STATUS = [
  { value: ACTIVE, label: 'Active' },
  { value: INACTIVE, label: 'Inactive' },
];
export const LMD_TABLE_HEADER = 'LMD_TABLE_HEADER';
export const LIFT_TABLE_HEADER = 'LIFT_TABLE_HEADER';
export const BUILDING_TABLE_HEADER = 'BUILDING_TABLE_HEADER';
export const LMD_LIFT_TABLE_HEADER = 'LMD_LIFT_TABLE_HEADER';
export const BUILDING_LIFT_TABLE_HEADER = 'BUILDING_LIFT_TABLE_HEADER';
export const RBE_TABLE_HEADER = 'RBE_TABLE_HEADER';
export const LIFT_ALARM_TABLE_HEADER = 'LIFT_ALARM_TABLE_HEADER';
export const LMD_ALARM_TABLE_HEADER = 'LMD_ALARM_TABLE_HEADER';
export const LIFT_FAULT_TABLE_HEADER = 'LIFT_FAULT_TABLE_HEADER';
export const PASSENGER_TRAP_TABLE_HEADER = 'PASSENGER_TRAP_TABLE_HEADER';
export const DEPLOYMENT = 'DEPLOYMENT';
export const OUTSTANDING = 'OUTSTANDING';
export const CLOSED = 'CLOSED';
export const EIMIT = 'menuItemOnClick';
export const FAULT_TABLESTATUS = 'operationalStatus';
export const NA = 'N/A';
export const PT_REPORTS_TABLE_HEADER = 'PT_REPORTS_TABLE_HEADER';
export const PT_REPORTS_FILTERS = 'PT_REPORTS_FILTERS';
export const PT_REPORTS_SORT = 'PT_REPORTS_SORT';
export const BREAKDOWN_REPORTS_TABLE_HEADER = 'BREAKDOWN_REPORTS_TABLE_HEADER';
export const BREAKDOWN_REPORTS_FILTERS = 'BREAKDOWN_REPORTS_FILTERS';
export const BREAKDOWN_REPORTS_SORT = 'BREAKDOWN_REPORTS_SORT';
export const RESET_PASSWD_VERIFICATION_CODE = 'RESET_PASSWD_VERIFICATION_CODE';
export const BREAKDOWN_CODE_SUMMARY_REPORTS_TABLE_HEADER =
  'BREAKDOWN_CODE_SUMMARY_REPORTS_TABLE_HEADER';
export const BREAKDOWN_CODE_SUMMARY_REPORTS_SORT = 'BREAKDOWN_CODE_SUMMARY_REPORTS_SORT';
export const SUMMARY_REPORT_FILTERS = 'BREAKDOWN_CODE_SUMMARY_REPORT_FILTERS';
export const CHRONIC_LIFTS = 'CHRONIC_LIFTS_REPORTS_FILTERS';
export const DATEFILDS = [
  'alarmClearTs',
  'alarmSetTs',
  'createdAt',
  'updatedAt',
  'lfAcknowledgeAt',
  'lfArrivalTs',
  'alarmAckTs',
  'ptReportAt',
  'ptAcknowledgeAt',
  'ptArrivalTs',
  'lfReportAt',
  'alarmEndTs',
  'arrivalTs',
  'closedAt',
  'firstComplaintAt',
  'acknowledgeAt',
  'alarmStartTs',
  'alarmClearTs',
  'startTs',
  'clearTs',
  'ackTs',
  'endTs',
  'assignTs',
  'createdTime',
];

export const FORMATDATE = 'DD/MM/YYYY HH:mm:ss';
export const DIVISION = 'DIVISION';
export const LIFTCOMPANY = 'LIFTCOMPANY';
export const DIVISION_LIFTCOMPANY = 'DIVISION_LIFTCOMPANY';
export const MONTH_FORMAT = 'MM/YYYY';
export const MONTH_PARMS = 'YYYY-MM';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const OMS_FORMAT = 'DD MMM YYYY HH:mm';
export const RECH_DATE = 'DD MMM HH:mm';
export const TC = 'TOWN_COUNCIL';
export const LIFT_COMPANY = 'LIFT_COMPANY';

export const COL1 = {
  labelStyle: { width: 210 },
  contentStyle: { width: 210 },
};
export const COL2 = {
  labelStyle: { width: 140 },
  contentStyle: { width: 210 },
};

export const REB_TITLE_CODE = [
  'LF0',
  'LF1',
  'LF2',
  'LF3',
  'LF4',
  'PTRP',
  'PMP0',
  'PMP1',
  'PMP2',
  'MOF',
  'PSF',
  'CDO',
  'LM',
  'RO',
  'LMDC',
  'ARDI',
  'CF',
  'BC',
];

export const divClass = 'border-b-[1px] border-[#E8E9ED] dark:border-[#ffffff21] mb-4';
